import type { Mission } from '../missions.ts'

export const cbpOt: Mission = {
  id: "cbp-ot",
  name: "Office of Trade",
  short: "OT",
  call: "Trade",
  kind: "subagency",
  parent: "cbp",
  url: "https://www.cbp.gov/trade",
  palette: {
    primary: "#356e8c",
    secondary: "#0a517f",
    accent: "#a81824",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Office_of_Trade_CBP_seal.jpg",
  },
  motif: "scales",
  mission: {
    text: "CBP works to enable legitimate trade, contribute to American economic prosperity, and protect against risks to public health and safety.",
    url: "https://www.cbp.gov/sites/default/files/assets/documents/2020-Dec/Office%20of%20Trade%20Strategy%202025_Final_0.pdf",
  },
  fact: {
    text: "The Office of Trade enforces over 500 U.S. trade laws and 14 free trade agreements, in collaboration with 49 partner government agencies.",
    url: "https://www.cbp.gov/about/leadership-organization/executive-assistant-commissioners-offices/trade",
  },
  seal: {
    file: "public/seals/cbp-ot.png",
    source: "https://commons.wikimedia.org/wiki/File:Office_of_Trade_CBP_seal.jpg",
  },
  identifier: {
    about: "https://www.cbp.gov/about",
    accessibility: "https://www.cbp.gov/site-policy-notices/accessibility",
    foia: "https://www.cbp.gov/site-policy-notices/foia",
    noFear: "https://www.cbp.gov/about/eeo/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.cbp.gov/document/publications/cbp-strategy-2021-2026",
    privacy: "https://www.cbp.gov/site-policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/cbp-ot-jacksonville-cargo.jpg",
        small: "/media/cbp-ot-jacksonville-cargo-sm.jpg",
        alt: "CBP officers and import specialists examine an open shipping container stacked with cartons at the Port of Jacksonville, with container stacks in the background.",
        title: "Inspecting shipments for intellectual property rights violations, Area Port of Jacksonville, February 21, 2019",
        creator: "Ozzy Trevino, CBP Photography, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:CBP_officers_and_import_specialists_assigned_to_the_Area_Port_of_Jacksonville,_inspect_shipments_of_possible_intellectual_property_rights_violations_(47298892902).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
